var oDoc = document;
ACC.navigation = {

    _autoload: [
        "setSelectedCategory",
        "offcanvasNavigation",
        "myAccountNavigation",
        "orderToolsNavigation",
        "loginActiveBlock",
        "forMobileTablet",
        "navlinkClickEvent",
        "searchBarTablet",
        ["conditionsModal", $('.page-login #popinAMDS').length > 0 && $('#showConditionsPopin').val() != ''],
        "menuTablet",
        "truncateAgencyName",
        ["removeConditionsCookie", $('.global-alerts').length > 0 && $.cookie('conditionErrorMessage') != null && $.cookie('conditionErrorMessage') != ''],
        ["sendingActivationEmailModal", $('.page-login #popinAMDS').length > 0 && ($('#showConditionsPopin').val() != '' && $('#showConditionsPopin').val() === 'E2')],
        ["sendingAnotherActivationEmailModal", $('.page-login #popinAMDS').length > 0 && ($('#showConditionsPopin').val() != '' && $('#showConditionsPopin').val() === 'S1')]
    ],
    setSelectedCategory: function () {
        $('.nav__link').removeClass('currentNode')
        $("span[data-category='"+ACC.currentCategory+"']").addClass('currentNode');
    },
    offcanvasNavigation: function() {

        enquire.register("screen and (max-width:"+screenSmMax+")", {

            match : function() {
                $(document).on("click",".js-enquire-offcanvas-navigation .js-enquire-has-sub .js_nav__link--drill__down",function(e){
                    e.preventDefault();
                    $(".js-userAccount-Links").hide();

                    if(!$(this).parent().hasClass('active')) {
                        $(".js-enquire-offcanvas-navigation .js_sub__navigation").slideUp(200);
                        $(this).next(".js_sub__navigation").slideDown(200);
                        $(".js-enquire-offcanvas-navigation ul.js-offcanvas-links").addClass("active");
                        $(".js-enquire-offcanvas-navigation .js-enquire-has-sub").removeClass("active");
                        $(this).parent(".js-enquire-has-sub").addClass("active");
                    } else {
                        $(".js-enquire-offcanvas-navigation .js_sub__navigation").slideUp(200);
                        $(".js-enquire-offcanvas-navigation .js-enquire-has-sub").removeClass("active");
                    }
                });

                $(document).on("click",".js-enquire-offcanvas-navigation .js-enquire-sub-close",function(e){
                    e.preventDefault();
                    $(".js-userAccount-Links").show();
                    $(".js-enquire-offcanvas-navigation ul.js-offcanvas-links").removeClass("active");
                    $(".js-enquire-offcanvas-navigation .js-enquire-has-sub").removeClass("active");
                });
            },

            unmatch : function() {
                $(".js-userAccount-Links").show();
                $(".js-enquire-offcanvas-navigation ul.js-offcanvas-links").removeClass("active");
                $(".js-enquire-offcanvas-navigation .js-enquire-has-sub").removeClass("active");
                $(".js-enquire-offcanvas-navigation .js_sub__navigation").removeAttr('style');

                $(document).off("click",".js-enquire-offcanvas-navigation .js-enquire-has-sub > a");
                $(document).off("click",".js-enquire-offcanvas-navigation .js-enquire-sub-close");
                $(document).off("click",".js-enquire-offcanvas-navigation .js-enquire-has-sub .js_nav__link--drill__down");
            }
        });
    },

    myAccountNavigation: function() {

        //copy the site logo
        // $('.js-mobile-logo').html( $('.js-site-logo a').clone());

        //Add the order form img in the navigation
        $('.nav-form').html($('<span class="glyphicon glyphicon-list-alt"></span>'));


        var aAcctData = [];
        var sSignBtn = "";

        //my account items
        var oMyAccountData = $(".accNavComponent");

        //the my Account hook for the desktop
        var oMMainNavDesktop = $(".js-secondaryNavAccount > ul");

        //offcanvas menu for tablet/mobile
        var oMainNav = $(".navigation--bottom > ul.nav__links.nav__links--products");

        if(oMyAccountData){
            var aLinks = oMyAccountData.find("a");
            for(var i = 0; i < aLinks.length; i++){
                aAcctData.push({link: aLinks[i].href, text: aLinks[i].title});
            }
        }

        var navClose = '<div class="close-nav"><span class="amds-icon-close"></span></div>';

        //create Sign In/Sign Out Button
        // if($(".liOffcanvas a") && $(".liOffcanvas a").length > 0){
        //     sSignBtn += '<li class=\"auto liUserSign\" ><a class=\"userSign\" href=\"' + $(".liOffcanvas a")[0].href + '\">' + $(".liOffcanvas a")[0].innerHTML + '</a></li>';
        // }

        //create Welcome User + expand/collapse and close button
        //This is for mobile navigation. Adding html and classes.
        var oUserInfo = $(".nav__right ul li.logged_in");
        //Check to see if user is logged in
        if(oUserInfo && oUserInfo.length === 1)
        {
            // var sUserBtn = '';
            // sUserBtn += '<li class=\"auto \">';
            // sUserBtn += '<div class=\"userGroup\">';
            // sUserBtn += '<span class="glyphicon glyphicon-user myAcctUserIcon"></span>';
            // sUserBtn += '<div class=\"userName\">' + oUserInfo[0].innerHTML + '</div>';
            // if(aAcctData.length > 0){
            //     sUserBtn += '<a class=\"collapsed js-nav-collapse\" id="signedInUserOptionsToggle" data-toggle=\"collapse\"  data-target=\".offcanvasGroup1\">';
            //     sUserBtn += '<span class="glyphicon glyphicon-chevron-up myAcctExp"></span>';
            //     sUserBtn += '</a>';
            // }
            // sUserBtn += '</div>';
            // sUserBtn += navClose;

            $('.js-sticky-user-group').html("<li><span>Menu</span></li><li class=\"sticky-nav-close js-toggle-sm-navigation\">" + navClose + "</li>");


            // $('.js-userAccount-Links').append(sSignBtn);
            // $('.js-userAccount-Links').append($('<li class="auto"><div class="myAccountLinksContainer js-myAccountLinksContainer"></div></li>'));


            //FOR DESKTOP
            var myAccountHook = $('<a class=\"myAccountLinksHeader collapsed js-myAccount-toggle\" data-toggle=\"collapse\" data-parent=".nav__right" href=\"#accNavComponentDesktopOne\">' + oMyAccountData.data("title") + '</a>');
            myAccountHook.insertBefore(oMyAccountData);

            //FOR MOBILE
            //create a My Account Top link for desktop - in case more components come then more parameters need to be passed from the backend
            var myAccountHook = [];
            myAccountHook.push('<div class="sub-nav">');
            myAccountHook.push('<a id="signedInUserAccountToggle" class=\"myAccountLinksHeader collapsed js-myAccount-toggle\" data-toggle=\"collapse\" data-target=".offcanvasGroup2">');
            myAccountHook.push(oMyAccountData.data("title"));
            myAccountHook.push('<span class="glyphicon glyphicon-chevron-down myAcctExp"></span>');
            myAccountHook.push('</a>');
            myAccountHook.push('</div>');

            $('.js-myAccountLinksContainer').append(myAccountHook.join(''));

            //add UL element for nested collapsing list
            $('.js-myAccountLinksContainer').append($('<ul data-trigger="#signedInUserAccountToggle" class="offcanvasGroup2 offcanvasNoBorder collapse js-nav-collapse-body subNavList js-myAccount-root sub-nav"></ul>'));


            //offcanvas items
            //TODO Follow up here to see the output of the account data in the offcanvas menu
            for(var i = aAcctData.length - 1; i >= 0; i--){
                var oLink = oDoc.createElement("a");
                oLink.title = aAcctData[i].text;
                oLink.href = aAcctData[i].link;
                oLink.innerHTML = aAcctData[i].text;

                var oListItem = oDoc.createElement("li");
                oListItem.appendChild(oLink);
                oListItem = $(oListItem);
                oListItem.addClass("auto ");
                $('.js-myAccount-root').append(oListItem);
            }

        } else {
            // var navButtons = (sSignBtn.substring(0, sSignBtn.length - 5) + navClose) + '</li>';
            $('.js-sticky-user-group').html("<li><span>Menu</span></li><li class=\"sticky-nav-close js-toggle-sm-navigation\">" + navClose + "</li>");
        }

        //desktop
        for(var i = 0; i < aAcctData.length; i++){
            var oLink = oDoc.createElement("a");
            oLink.title = aAcctData[i].text;
            oLink.href = aAcctData[i].link;
            oLink.innerHTML = aAcctData[i].text;

            var oListItem = oDoc.createElement("li");
            oListItem.appendChild(oLink);
            oListItem = $(oListItem);
            oListItem.addClass("auto col-md-4");
            oMMainNavDesktop.get(0).appendChild(oListItem.get(0));
        }

        //hide and show contnet areas for desktop

        $('.js-secondaryNavAccount').on('shown.bs.collapse', function () {
            if($('.js-secondaryNavCompany').hasClass('in')) {
                $('.js-myCompany-toggle').click();
            }
        });

        $('.js-secondaryNavCompany').on('shown.bs.collapse', function () {
            if($('.js-secondaryNavAccount').hasClass('in')) {
                $('.js-myAccount-toggle').click();
            }
        });

        //change icons for up and down

        $('.js-nav-collapse-body').on('hidden.bs.collapse', function(e) {
            var target = $(e.target);
            var targetSpan = target.attr('data-trigger') + ' > span';

            if(target.hasClass('in')) {
                $(targetSpan).removeClass('glyphicon-chevron-down').addClass('glyphicon-chevron-up');
            } else {
                $(targetSpan).removeClass('glyphicon-chevron-up').addClass('glyphicon-chevron-down');
            }
        });

        $('.js-nav-collapse-body').on('show.bs.collapse', function(e) {
            var target = $(e.target);
            var targetSpan = target.attr('data-trigger') + ' > span';

            if(target.hasClass('in')) {
                $(targetSpan).removeClass('glyphicon-chevron-up').addClass('glyphicon-chevron-down');
            } else {
                $(targetSpan).removeClass('glyphicon-chevron-down').addClass('glyphicon-chevron-up');
            }
        });

        $('.js_search_button').on('click', function(e) {
            var searchInput = $(this).closest('.input-group').find('.js-site-search-input');

            if(searchInput.val() == "") {
                searchInput.focus();
                return false;
            }

            if(searchInput.parents( "div.site-search" ).length > 0){

                ACC.track.centralSearchEvent(searchInput.val());

            }
        });

        $( document ).ready(function() {
            if($.cookie("activeSearchBar")) {
                $('.js_search_button').closest('.input-group').removeClass('show-search hide-search').addClass('show-search');
            }
        });

        $('.js_search_button').on('mouseenter', function(e) {
            var searchInput = $(this).closest('.input-group').find('.js-site-search-input');

            if(!$("header.js-mainHeader").hasClass('sticky-header')) {
                $.cookie('activeSearchBar', true, { path: '/' });
                $(this).closest('.input-group').removeClass('show-search hide-search').addClass('show-search');
            }
        });

//        $('.amds-header-nav .ui-front .input-group').on('mouseleave', function(e) {
//            var that = $(this);
//
//            if(!$("header.js-mainHeader").hasClass('sticky-header') && $('.js-site-search-input').val() == "") {
//                that.addClass('hide-search');
//
//                setTimeout(function () {
//                    that.removeClass('show-search hide-search');
//                }, 150);
//            }
//        });

//        $('.js-site-search-input').on('keyup focusout', function(e) {
//            var that = $(this);
//
//            if(!$("header.js-mainHeader").hasClass('sticky-header') && that.val() == "" && !that.is(":focus")) {
//                that.closest('.input-group').addClass('hide-search');
//
//                setTimeout(function () {
//                    that.closest('.input-group').removeClass('show-search hide-search');
//                }, 150);
//            }
//        });

        var h = 0,
            isFirstScroll = 0;

        $(window).scroll(function() {

            if(isFirstScroll == 0) {
                h = $(document).height() - $(window).height();
                isFirstScroll = 1;
            }

            var winTop = $(window).scrollTop(),
                header = $("header.js-mainHeader"),
                toTop = $(".toTop");

            if(winTop >= 50 && h >= 250) {
                header.addClass("sticky-header");
                header.find('.site-search .input-group').addClass('show-search');
                toTop.fadeIn();
            } else {
                header.removeClass("sticky-header");
                if(header.find('.site-search .input-group .js-site-search-input').val() == "") {
                    header.find('.site-search .input-group').removeClass('show-search');
                }
                toTop.fadeOut();
            }
        });

        $('.toTop').click(function () {
            $("html, body").animate({
                scrollTop: 0
            }, 600);
            if($(".checkout__confirmation__content--component a .inline-block .image-container").length > 0){
                ACC.track.orderConfirmationBannerViewEvent();
            }
            return false;
        });

        //$('.offcanvasGroup1').collapse();
    },

    orderToolsNavigation: function() {
        $('.js-nav-order-tools').on('click', function(e){
            $(this).toggleClass('js-nav-order-tools--active');
        });
    },

    loginActiveBlock: function() {
        $('.loginPage').on('mouseenter', '.yCmsContentSlot', function() {
            $('.yCmsContentSlot').removeClass('active-side');
            $(this).addClass('active-side');
        });
    },

    forMobileTablet: function() {
        if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && $(window).width() >= 1000 && $(window).width() < 1024) {
            // supprimer le href des liens pour empecher l'ouverture des PLP, et pour ouvrir les sous-menu.
            $('.nav__links--products > li > .nav__link-element > .nav__link a').removeAttr('href');
        }
    },

    searchBarTablet: function() {
        $(window).on('load resize', function() {
            if($(window).width() <= 1024 && $('.input-group-btn.btnResponsive').length == 0) {
                var searchBtn = $('header .amds-header-nav-search .input-group-btn');
                searchBtn.after(searchBtn.clone().addClass('btnResponsive'));
            } else if($(window).width() > 1024 && $('.input-group-btn.btnResponsive').length > 0) {
                $('header .amds-header-nav-search .input-group-btn.btnResponsive').remove();
            }
        });
    },

    sendingActivationEmailModal: function() {
        $('#popinAMDS .sendingActivationEmail').on('click', function(e) {
            e.preventDefault();
            $.ajax({
                url: ACC.config.encodedContextPath + '/login/sendReactivationEmail?username=' + $('#userName').val(),
                type: 'GET',
                dataType: "json",
                success: function (result) {
                    $('#E2').modal('toggle');
                    ACC.navigation.showConditionModal("emailSent");
                    $('.btn-close').on('click', function(e) {
                        $('#emailSent').modal('toggle');
                    });
                }
            });
        });
    },

    sendingAnotherActivationEmailModal: function() {
        $('#popinAMDS .sendingAnotherActivationEmail').on('click', function(e) {
            e.preventDefault();
            $.ajax({
                url: ACC.config.encodedContextPath + '/login/sendReactivationEmail?username=' + $('#userName').val(),
                type: 'GET',
                dataType: "json",
                success: function (result) {
                    $('#S1').modal('toggle');
                }
            });
        });
    },

    conditionsModal: function() {
        var conditionToShow = $('#showConditionsPopin').val();

        ACC.navigation.showConditionModal(conditionToShow);

        $('#popinAMDS .acceptConditions').on('click', function(e) {
            e.preventDefault();

            $.ajax({
                url: ACC.config.encodedContextPath + '/login/acceptConditions',
                type: 'POST',
                dataType: "json",
                success: function (nextCondition) {
                    $('#popinAMDS .popinCondition[data-condition=' + conditionToShow + ']').modal('toggle');

                    conditionToShow = nextCondition;

                    setTimeout(function(){
                        if(nextCondition === 'CGU' || nextCondition === 'PPD') {
                            ACC.navigation.showConditionModal(nextCondition);
                        } else {
                            window.location.href = nextCondition;
                        }
                    }, 300);
                }
            });
        });

        $('#popinAMDS .dontAcceptConditions').on('click', function(e) {
            e.preventDefault();

            $.cookie("conditionErrorMessage", $(this).closest('.popinCondition').data('condition'));

            window.location.href = ACC.config.encodedContextPath + '/login/dontAcceptConditions';
        });
    },

    showConditionModal: function(conditionToShow) {
        var popinCondition = $('#popinAMDS .popinCondition[data-condition=' + conditionToShow + ']'),
            modalBody = popinCondition.find('.modal-body'),
            modalBodyScroll = popinCondition.find('.modal-body-scroll');
        popinCondition.removeClass('hidden').modal({backdrop: 'static', keyboard: false});

        setTimeout(function() {
            var windowH = $(window).height();
            var modalBodyH = modalBody.height();

            if(modalBodyH > windowH/2) {
                modalBodyScroll.height(windowH/2);
            } else {
                modalBodyScroll.removeAttr('style');
            }

            modalBodyScroll.perfectScrollbar().scrollTop(0).perfectScrollbar('update');
        }, 200);
    },

    menuTablet: function() {
        var menu = $('.js-mainHeader .amds-header-menu'),
            menuLinks = menu.find('.nav__links--primary .js_nav__link a');
        if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && $(window).width() >= 1024) {

            $(menuLinks).each(function(i, el) {
                $(el).on('mouseenter', function(e){
                    if(/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
                        if(!$(el).hasClass('clicked')) {
                            ACC.navigation._addClickedClassMenuLink(el);
                        }
                    }
                });

                $(el).on('click', function(e){
                    e.preventDefault();

                    if(!$(el).hasClass('clicked')) {
                        ACC.navigation._addClickedClassMenuLink(el);
                    } else {
                        window.location.href = $(el).attr('href');
                    }
                });
            });
        }
        else if(navigator.maxTouchPoints > 0 && $(window).width() >= 1024) {
            $(menuLinks).each(function(i, el) {
                $(el).on('click', function(e){
                    ACC.navigation.closeAll();
                    e.preventDefault();
                    if(!$(el).hasClass('clicked')) {
                        ACC.navigation._addClickedClassMenuLink(el);
                        $(el).closest("li").trigger("mouseover");
                    } else {
                        window.location.href = $(el).attr('href');
                    }
                });
            });
            $('.amds-header-nav-icon').on('click',function(){
                $('.js-mainHeader .amds-header-menu .nav__links--primary .js_nav__link a').removeClass('clicked');
                $(this).trigger("mouseover");
            })

        }
    },
    closeAll: function(){
        $('.js-mainHeader .amds-header-menu li').trigger("mouseout")
    },
    _addClickedClassMenuLink: function(el) {
        var menuLinks = $('.js-mainHeader .amds-header-menu .nav__links--primary .js_nav__link a');

        $(el).addClass('clicked');
        menuLinks.not(el).removeClass('clicked');
    },

    navlinkClickEvent : function (){
        var menu = $('.js-mainHeader .amds-header-menu');
        var menuLinks = menu.find('.nav__links--primary .js_nav__link a');
        $(menuLinks).each(function(i, el) {
            $(el).on('click', function(e){
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event':'click_menu',
                    'category_name': $(el).attr('title')
                });
            });
        });
    },

    truncateAgencyName: function () {
        var length = 10;
        var agencyName = null;
        var truncated_text = null;
        agencyName = $('.amds-header-store .nav-store-text > span:eq(1)');
        var spaceCount = ($.trim(agencyName.text()).split(" ").length - 1);

        if($.trim(agencyName.text()).replace(" ", "").length > length) {
            truncated_text = $.trim(agencyName.text()).substring(0, length + spaceCount);

            while (truncated_text.substring(truncated_text.length-1,truncated_text.length) == " ") {
                truncated_text = truncated_text.substring(0 , truncated_text.length-1);
            }

            truncated_text+= "...";
            agencyName.html(truncated_text);
        }
    },

    removeConditionsCookie: function() {
        $.cookie("conditionErrorMessage", "");
    }
};